export default __webpack_public_path__ + "static/media/Nitroxgallery_78.4a953ec5.JPG";